import { useContext } from 'react';

import { OrderContext } from '../context';

export const useOrderContext = () => {
  const ctx = useContext(OrderContext);
  if (!ctx) {
    throw new Error(
      'useOrderContext must be used within OrderContext.Provider',
    );
  }
  return ctx;
};

// Loader components rendered by OrderPage before OrderContext.Provider mounts (i.e. while
// viewModel.isLoading) need to read the context safely — return undefined instead of throwing.
export const useOrderContextOptional = () =>
  useContext(OrderContext) ?? undefined;
